import React from 'react';

import { List } from '@atom/mui';
import colors from '@atom/styles/colors';
import { WorkOrderResult } from '@atom/types/search';
import history from '@atom/utilities/history';
import { getWorkIconByStatusId } from '@atom/utilities/iconUtilities';
import { highlightedText } from '@atom/utilities/textDisplayUtilities';

import './searchPortal.css';

const { ListItemButton, ListItem, ListItemText } = List;

const style = {
  listItem: {
    padding: 0,
    margin: 0,
    borderBottom: `1px solid ${colors.neutral.typhoon}`,
  },
  listItemButton: {
    height: '3.5rem',
  },
};

interface Props {
  query: string;
  work: WorkOrderResult;
}

const WorkResultRow = ({ query, work }: Props) => {
  const name = highlightedText(query, work.name);
  const icon = getWorkIconByStatusId(work.statusId);

  return (
    <ListItem style={style.listItem} key={work.id} disablePadding>
      <ListItemButton
        disableGutters
        onClick={() => history.push(`/workOrders/${work.id}`)}
        style={style.listItemButton}
      >
        <div styleName="icon-container-work">{icon}</div>
        <ListItemText disableTypography primary={name} />
      </ListItemButton>
    </ListItem>
  );
};

export default WorkResultRow;
